import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { EmailValidator } from 'src/app/services/email.validator';
import { UsersService } from './../../services/users.service';
import { AppConfigService } from './../../services/app-config.service';
import { LoadingService } from './../../services/loading.service';
import { CookieService } from 'ngx-cookie-service';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { Message } from 'src/app/interfaces/message.model';



@Component({
  selector: 'vex-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInUp400ms
  ]
})
export class LoginComponent implements OnInit {


  userEmailLogin: FormGroup;
  floatLabelControl = new FormControl('always');
  loginStatus: boolean = false;
  user_det: any;
  session: string = '';
  errorStatus: boolean = false;
  statusMessage: any;
  form: FormGroup;

  inputType = 'password';
  visible = false;

  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;

  constructor(private router: Router,
              private fb: FormBuilder,
              private cd: ChangeDetectorRef,
              private snackbar: MatSnackBar,
              private userService: UsersService,
              private appConfigService: AppConfigService,
              private loadingService: LoadingService,
              private CookieService : CookieService,
              private broadcastService:BroadcastService,
              
  ) {

  }

  @HostListener('document:keypress', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.onUserEmailLogin(this.userEmailLogin)
    }
}

  ngOnInit() {
    if(this.CookieService.get('user_session_id')){
      history.back()
    }
    this.userEmailLogin = this.fb.group({
      login_email: new FormControl('', Validators.compose([Validators.required, Validators.email,Validators.pattern(/[a-z0-9]+@[a-z0-9]+\.[a-z0-9]{2,2}/), EmailValidator.cannotContainSpace])),
      login_email_password: new FormControl('', [ Validators.required])
    })

    this.userService.removeUserLocalStorage()
    userPrivileges = localStorage.getItem('user_privileges')
    // ////console.log(localStorage.getItem('user_privileges'))
   
  }

  ngOnDestroy(){
    location.reload()
  }

  send() {
    this.router.navigate(['/dashboard']);
    this.snackbar.open('Lucky you! Looks like you didn\'t need a password or email address! For a real application we provide validators to prevent this. ;)', 'LOL THANKS', {
      duration: 10000
    });
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }

  checkWhitSpaces(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode === 32) {
      return false;
    }
    return true;
  }

  onUserEmailLogin(userCredentials: any){
    this.loadingService.showLoader();
    ////console.log("the user details are",userCredentials)
  
  

    if(userCredentials.status === 'VALID'){
      let url = location.href;
      if(url.split("#")[1] != "/"){
        // this.loadingService.hideLoader();
      }

      this.userService.emailLogin(userCredentials).subscribe(
      (response) => {
        var userId1 = response['data']['active_sessions']
        var userId = userId1[userId1.length - 1];
        this.loginStatus = true;
        console.log("the login",JSON.stringify(response))
       
        this.user_det = {
          status: true,
          user_session_id: userId,
          user_name: response["data"]["first_name"],
          user_email: response["data"]["email"],
          user_cms_token : response["data"]["bg_auth_token"],
          user_privileges: response["data"]["user_privileges"],
          service_brought:response["data"]["service_brought"],
          user_role: response["data"]["user_role"],
          cms_bg_id:response['data']['bg_id'],
          transcode_bg_id:response['data']['bg_id'],
          business_group_id:response['data']['business_group_id'],
          tenant_ids:response['data']['bg_tenants']

        }

console.log("the user details are",JSON.stringify(this.user_det))
        this.userService.setUserLocalStorage(this.user_det);
        this.appConfigService.loadCmsKeys(this.user_det.user_cms_token);

        userPrivileges = response["data"]["user_privileges"]
        
        
        // localStorage.setItem('loggedInUserDetails', JSON.stringify(response.data))
        this.session = userId;
        let url = location.href;
        if(url.split("#")[1] != "/"){

        }
        this.loadingService.hideLoader();
        // if(this.user_det.user_role === 'cms_manager'){
        //   this.router.navigate(['/cms/business-group']);
        // }else if(this.user_det.service_brought === 'OTT'){
        if(this.user_det.user_role === 'cms_manager' || this.user_det.user_role === 'content_editor' || this.user_det.user_role === 'admin'){
        this.router.navigate(['/cms/catalogs']);
        }else if(this.user_det.user_role === 'customer_support'){
          this.router.navigate(['/cms/monetization/subscription/end-user-details']);
        }
        // }else{
        //   this.router.navigate(['/cms/transcoding/catalogs']);
        // }
        
        if(localStorage.getItem('user_privileges')){
          userPrivileges = response["data"]["user_privileges"]
        }
        
        },
        (error: any) => {
          this.loadingService.hideLoader();
          ////console.log("the error is",error.server_error_messsage)
          this.snackbar.open(error.server_error_messsage, '', {
            duration: 3000,
            panelClass: 'snackbar-container'
          });
        }
      );
    }else{
      this.loadingService.hideLoader()
      this.snackbar.open("Please enter Email Id and Password to login", '',{
        duration:2000
      })
    }

 }

}

export let userPrivileges =  localStorage.getItem('user_privileges')
